import {
  // -- GET (list)
  GET_GLOBAL_LOCATIONS_SUCCESS,
  GET_GLOBAL_LOCATIONS_FAILURE,
  // -- CREATE
  CREATE_GLOBAL_LOCATION_SUCCESS,
  CREATE_GLOBAL_LOCATION_FAILURE,
  // -- UPDATE
  UPDATE_GLOBAL_LOCATION_SUCCESS,
  UPDATE_GLOBAL_LOCATION_FAILURE,
  // -- DELETE
  DELETE_GLOBAL_LOCATION_SUCCESS,
  DELETE_GLOBAL_LOCATION_FAILURE
} from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

export const globalLocations = (state = {}, action) => {
  switch (action.type) {
    // -- GET GLOBAL LOCATIONS (list)
    case GET_GLOBAL_LOCATIONS_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalLocations.GET_GLOBAL_LOCATIONS_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_GLOBAL_LOCATIONS_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalLocations.GET_GLOBAL_LOCATIONS_SUCCESS()', { state, action })
      return {
        ...state,
        items: action.data
      }
    }

    // -- CREATE GLOBAL LOCATION
    case CREATE_GLOBAL_LOCATION_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalLocations.CREATE_GLOBAL_LOCATION_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case CREATE_GLOBAL_LOCATION_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalLocations.CREATE_GLOBAL_LOCATION_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE GLOBAL LOCATION
    case UPDATE_GLOBAL_LOCATION_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalLocations.UPDATE_GLOBAL_LOCATION_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case UPDATE_GLOBAL_LOCATION_SUCCESS: {
      const newItems = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalLocations.UPDATE_GLOBAL_LOCATION_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }

    // -- DELETE GLOBAL LOCATION
    case DELETE_GLOBAL_LOCATION_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalLocations.DELETE_GLOBAL_LOCATION_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case DELETE_GLOBAL_LOCATION_SUCCESS: {
      const newItems = state.items.filter((obj) => obj.id !== action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalLocations.DELETE_GLOBAL_LOCATION_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }

    default:
      return state
  }
}
